import './styles.scss'

import { useTranslation } from 'react-i18next'
import { FileTextOutlined } from '@ant-design/icons'
import { Col, Row } from 'antd'

import CollapsedRadio from '@/components/CollapsedRadio'

export default function PaymentMethod() {
  const { t } = useTranslation()

  const dataSource = [
    {
      label: t('checkout.step2.invoice'),
      icon: <FileTextOutlined />,
      value: 'invoice',
      children: null,
    },
  ]

  return (
    <Row className="payment-method__wrapper checkout-step1-section__wrapper">
      <Col lg={5} md={4} sm={24} xl={5} xs={24}>
        <h3>{t('checkout.step2.paymentMethod')}</h3>
      </Col>
      <Col lg={13} md={20} sm={24} xl={13} xs={24}>
        <CollapsedRadio
          expandIcon
          className="custom-form-item"
          dataSrc={dataSource}
          formName="paymentMethod"
          initialValue={dataSource[0].value}
        />
      </Col>
    </Row>
  )
}
